import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
  name: "search",
  initialState: {
    loading: true,
    emptyCount: 0,
    digikey: [],
    arrow: [],
    mouser: [],
    avnet: [],
    ti: [],
    tti: [],
    element14: [],
    distributor: [],
    rutronik: [],
    tme: [],
  },
  reducers: {
    increaseSearchEmptyCount: (state, param) => {
      const { payload } = param;
      state.emptyCount += 1;
    },
    resetSearchEmptyCount: (state, param) => {
      const { payload } = param;
      state.emptyCount = 0;
    },
    setSearchLoading: (state, param) => {
      const { payload } = param;
      state.loading = payload;
    },
    setDistributorData: (state, param) => {
      const { payload } = param;
      state[payload.name] = payload.data;
    },
    resetDistributorData: (state, param) => {
      state = {
        digikey: [],
        arrow: [],
        mouser: [],
        avnet: [],
        ti: [],
        tti: [],
        element14: [],
        distributor: [],
        rutronik: [],
        tme: [],
      };
    },
  },
});
const { actions } = searchSlice;
export const {
  setDistributorData,
  resetDistributorData,
  setSearchLoading,
  increaseSearchEmptyCount,
  resetSearchEmptyCount,
} = actions;

export default searchSlice.reducer;
